/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ImageStructure } from './ImageStructure';
import type { NaturalLanguageStringStructure } from './NaturalLanguageStringStructure';

export type InfoLinkStructure = {
  uri: string;
  label?: NaturalLanguageStringStructure;
  image?: ImageStructure;
  linkContent?: InfoLinkStructure.linkContent;
};

export namespace InfoLinkStructure {
  export enum linkContent {
    TIMETABLE = 'TIMETABLE',
    RELATED_SITE = 'RELATED_SITE',
    DETAILS = 'DETAILS',
    ADVICE = 'ADVICE',
    OTHER = 'OTHER',
  }
}
